export default __webpack_public_path__ + "static/media/PalmIcon.f6db3c57.svg";